import React, { useRef } from 'react'

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useToast,
  useDisclosure,
} from '@chakra-ui/react'
import { useDispatch } from 'react-redux'

import {
  clearStaffInstance,
  deactivateStaff,
} from '../../redux/features/staffSlice'

const DeactivateStaffButton = ({ onSuccess }) => {
  const cancelRef = useRef(null)
  const toast = useToast()

  const dispatch = useDispatch()

  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleSuccess = () => {
    toast({
      title: 'Staff deactivated',
      description: `Staff was deactivated. Their previous casework have not been changed, but they will no longer be able to login.`,
      status: 'success',
    })
    onClose()
    onSuccess()
    dispatch(clearStaffInstance())
  }

  const handleDeactivate = () => {
    dispatch(deactivateStaff({ callbackSuccess: handleSuccess }))
  }

  return (
    <>
      <Button colorScheme='red' onClick={onOpen}>
        Deactivate
      </Button>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Deactivate Staff
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You will need to contact the Web Development Unit to
              reactivate this account.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme='red' onClick={handleDeactivate} ml={3}>
                Deactivate Staff
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}

export default DeactivateStaffButton
